import { formatDate, getTime } from '@/helpers/format-date';
import i18n from '@/api/i18n/i18n';

export const getDataField = (item, field) => {
  const value = item[field];
  if (!value) return '';
  const mappings = {
    reasonString: () => i18n.t(`db.${field}.${item.reasonId}`),
    categoryName: () => i18n.t(`db.${field}.${item.categoryId}`),
    eventTime: () => `${formatDate(value)} ${getTime(value)}`,
    date: () => `${formatDate(value)} ${getTime(value)}`,
    checkTime: () => {
      const date = new Date(value);
      return date.getTime() === 0 ? '' : value;
    },
    descriptionOutput: () => value.slice(0, 134),
  };
  return mappings[field] ? mappings[field]() : value;
};
